import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import TestMultipleChoiceFormFeedback from './TestMultipleChoiceFormFeedback'
import TestMultipleChoiceFormFonts from './TestMultipleChoiceFormFont'
import TestMultipleChoiceFormStyle from './TestMultipleChoiceFormStyle'
import type {
  TestMultipleChoiceFormBrandType,
  TestMultipleChoiceBrandForms,
} from './testMultipleChoiceTypes'

const FORM_MAP: TestMultipleChoiceBrandForms = {
  [BrandFormEnum.STYLE]: TestMultipleChoiceFormStyle,
  [BrandFormEnum.FEEDBACK]: TestMultipleChoiceFormFeedback,
  ...TestMultipleChoiceFormFonts,
}

const TestMultipleChoiceFormBrand: TestMultipleChoiceFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(TestMultipleChoiceFormBrand) as typeof TestMultipleChoiceFormBrand
